document.addEventListener('DOMContentLoaded', function() {
  GeoRedirect.fetchData(function (location) {
    var currentCountry = location.country_code;
    var excludingCountries = ['IQ', 'EG', 'LB', 'SY', 'PS', 'YE', 'IL', 'TR', 'MX', 'MA', 'MY'];
    var sportswearOnlyCountries = ['IL', 'TR', 'MX', 'MA', 'MY'];

    var DEV = false && location.ip == '80.109.151.154';

    if (excludingCountries.indexOf(location.country_code) !== -1 || DEV) {

      var isSportswearOnly = sportswearOnlyCountries.indexOf(location.country_code) !== -1;

      
      function isFitnessLink(href) {
        return href.indexOf('fitness') !== -1;
      }

      function removeNode(node) {
        if (typeof node === 'undefined' || node === null) {
          return;
        }
        if (typeof node.remove !== 'function') { // IE
          if (node.parentNode === null) {
            return;
          }
          node.parentNode.removeChild(node); 
        } else {
          node.remove();
        }
      }

      function removeFitnessLinks(nodeList) {
        for (var i = 0; i < nodeList.length; i++) {
          if (isFitnessLink(nodeList[i].href) && window.location.pathname !== '/') {
            removeNode(nodeList[i]);
          }
        }
      }

      // Cart selectable gifts (regular + gold) are Vue-rendered from /cart?view=rewards and can
      // include nutrition products (tagged product_line_fitness). Drop them from the reward arrays
      // so sportswear-only countries only ever get sportswear gifts (e.g. socks).
      function filterNutritionRewards() {
        if (typeof window.vueapp === 'undefined' || window.vueapp === null || !window.vueapp.cartData) {
          return;
        }
        var cartRewards = window.vueapp.cartData.cartRewards;
        if (!cartRewards) {
          return;
        }
        var rewardKeys = ['regular', 'gold'];
        var changed = false;
        for (var k = 0; k < rewardKeys.length; k++) {
          var key = rewardKeys[k];
          var list = cartRewards[key];
          if (Object.prototype.toString.call(list) !== '[object Array]') {
            continue;
          }
          var kept = [];
          for (var r = 0; r < list.length; r++) {
            var p = list[r];
            var isNutrition = p && p.tags && typeof p.tags.join === 'function' && p.tags.join(' ').indexOf('product_line_fitness') !== -1;
            if (!isNutrition) {
              kept.push(p);
            }
          }
          if (kept.length !== list.length) {
            window.vueapp.$set(window.vueapp.cartData.cartRewards, key, kept);
            changed = true;
          }
        }
        // Re-sync the jQuery variant dropdowns (selectpicker) after the array changed,
        // otherwise a removed gift's variant label can linger on the remaining cards.
        if (changed && typeof window.vueapp.refreshSelect === 'function') {
          window.vueapp.refreshSelect();
        }
      }


      function modifyFitnessAddToCartButton(node) {
        if (typeof node === 'undefined' || node === null) {
          return; 
        }
        node.setAttribute('disabled', true);
        node.style.color = '#000';
        node.style.background = '#f5f5f5';
        node.style.pointerEvents = 'none';
        node.style.display = 'flex';
        node.style.alignItems = 'center';
        node.style.justifyContent = 'center';
        var nodeSpan = node.querySelector('span');
        if(nodeSpan !== null){
        nodeSpan.style.fontSize = '12px';
        nodeSpan.style.whiteSpace = 'normal';
        nodeSpan.innerText = 'From your country it\'s only possible to order Sportswear';
          }
      }

      // These two are client-side redirects, so they have to be gated the same
      // way as the geo redirect: a crawler or a page-speed run reaching them
      // gets moved off the URL it asked for. The link/search cleanup below is
      // cosmetic and stays unconditional.
      var mayRedirect = !(window.WBBot && window.WBBot.isBot())
        && !(window.GeoRedirect && GeoRedirect.isDatacenterIp && GeoRedirect.isDatacenterIp(location));

      if (mayRedirect) {
        if (isSportswearOnly) {
          if (window.location.pathname === '/') {
            window.location.replace('https://www.womensbest.com/pages/sportswear');
          }
        }

        if (isFitnessLink(window.location.href)) {
          window.location.replace('https://www.womensbest.com/pages/sportswear');
        }
      }

      removeFitnessLinks(document.querySelectorAll('a'));
      removeNode(document.getElementById('headersearchtoggle'));
      removeNode(document.getElementById('headersearchtoggle-mobile'));

      // The removal above runs once on DOMContentLoaded, so nutrition links rendered later by
      // Vue (cart upsells, recommendations, quick-add) are missed. Re-scan on DOM mutations (debounced).
      if (typeof MutationObserver !== 'undefined' && document.body !== null) {
        var nutritionRescanScheduled = false;
        var nutritionObserver = new MutationObserver(function () {
          if (nutritionRescanScheduled) {
            return;
          }
          nutritionRescanScheduled = true;
          setTimeout(function () {
            nutritionRescanScheduled = false;
            removeFitnessLinks(document.querySelectorAll('a'));
            if (isSportswearOnly) {
              filterNutritionRewards();
            }
          }, 400);
        });
        nutritionObserver.observe(document.body, { childList: true, subtree: true });
      }
      
     

      if (document.querySelector('.fitness-info-flex') !== null) {
        var nodeList = document.querySelectorAll('.wb-single-product_meta-container .wb-product-addtocart-btn');
        for (var i = 0; i < nodeList.length; i++) {
          modifyFitnessAddToCartButton(nodeList[i]);
        }
      }

      if (document.querySelector('.bp-refer-friends') !== null) {
        removeNode(document.querySelector('.bp-refer-friends'));
      }


      
      if (document.querySelector('.regulation-country') !== null) {
        document.querySelector('.regulation-country').innerHTML = location.country_name;
      }

      removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-athlete-series"]'));
      removeNode(document.querySelector('#sidenav-main .wb-header__sidenav__main__panel__list a[href="#sidenav-athlete-series"]'));

      if (isSportswearOnly) {
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-fitness"]'));
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-beauty"]'));
        removeNode(document.querySelector('#wb-hdr19 .wb-hdr19-main a[data-href="#flyout-foods"]'));

        // After the header redesign the nutrition mega-menu/panel are single containers.
        // Remove them entirely so nutrition product links inside them don't linger in the DOM.
        removeNode(document.getElementById('flyout-fitness'));
        removeNode(document.getElementById('side-nav-fitness'));

        // Mobile Nutrition tab switcher is a <div data-category="fitness"> with no href,
        // so removeFitnessLinks never sees it. Remove its wrapping link.
        var mobileNutritionTab = document.querySelector('#sidenav-mainheader [data-category="fitness"]');
        if (mobileNutritionTab !== null) {
          removeNode(mobileNutritionTab.parentNode);
        }

        // Nutrition quiz links (e.g. /pages/gut-health-quiz) don't contain "fitness",
        // so they slip past removeFitnessLinks. Remove them explicitly.
        var nutritionQuizLinks = document.querySelectorAll('a[href*="gut-health-quiz"]');
        for (var nq = 0; nq < nutritionQuizLinks.length; nq++) {
          removeNode(nutritionQuizLinks[nq]);
        }

        // Also strip nutrition products from the cart's selectable regular + gold gifts
        // (in case they were already loaded before this ran; the observer covers later loads).
        filterNutritionRewards();

        if(document.querySelector('#wb-product-ctl-nutrition') !== null){
        document.querySelector('#wb-product-ctl-nutrition').remove();
        }

        if (document.querySelector('.mexican-sportswear-alert') !== null) {
          var mexAlertCountry = document.querySelector('.mexican-sportswear-alert strong');
          if (mexAlertCountry !== null && location.country_name) {
            mexAlertCountry.textContent = location.country_name;
          }
          document.querySelector('.mexican-sportswear-alert').style.display = 'block';
        }
      }

    }

  });
});